import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { withRouter, useLocation } from 'react-router';
import Layout from '../../LayoutFlow/views/App';
import { shape } from 'prop-types';
import { useTranslation } from 'react-i18next';
import ChatBox from '../../../../components/ChatBox';
import InputQuestionBox from '../../../../components/InputQuestionBox';

import {
  getMatchData,
  setMatchData,
  resetMatchData,
} from '../../../Marketplace/Market/store';

import {
  removeFromCheckout,
  resetSkippedSteps,
} from '../../../Marketplace/LayoutMarket/store';

import {
  getComponentName,
  getNextPath,
  addChatboxAnswer,
  addChatboxQuestion,
  showErrorPopup,
  setNoticeKey,
  getAllCoverages,
  addBrowserHistory,
} from '../../../../store';

import {
  sendCarData,
  sendCarExtraData,
  setInsuredData,
  getInsuredData,
} from '../store/index';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import DateInput from '../../../../components/DateInput';
import ApiRoutes from '../../../../store/ApiRoutes';
import { useFlowStore } from '../../../../services/context/LouiseFlowContext';

const OldInsuranceStartDateInput = ({ history }) => {
  const api = new ApiRoutes();
  const { t } = useTranslation();
  addChatboxQuestion(t(`${getComponentName()}.question`));
  const content = t(getComponentName(), { returnObjects: true });
  const [isDisabled, setIsDisabled] = useState(true);
  const [isPending, setIsPending] = useState(false);
  const [answer, setAnswer] = useState(null);
  const [finishedFetch, setFinishedFetch] = useState({});
  const [valuesHook, setValuesHook] = useState(null);
  const [valueChatMessage, setValueChatMessage] = useState(null);
  const [sendStep, setSendStep] = useState('initial');
  const location = useLocation();
  const coverages = getAllCoverages();
  const flowStore = useFlowStore();

  const tempCov = [
    {
      type: 'home',
      bool: coverages.home,
    },
    {
      type: 'family',
      bool: coverages.family,
    },
    {
      type: 'car',
      bool: coverages.car,
    },
  ];
  let covCount = 0;
  tempCov.map(coverage => {
    if (coverage.bool) {
      covCount += 1;
    }
  });

  let dateFormat = `DD-MM-YYYY`;
  let dateRegex = /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/;

  const SignupSchema = Yup.object().shape({
    insurance_date: Yup.string()
      .required(t(`OldInsurance.errors.invalid_date`))
      .nullable()
      .matches(dateRegex, t(`OldInsurance.errors.invalid_date`))
      .test('DOB', t(`OldInsurance.errors.invalid_date`), value =>
        moment(value, dateFormat).isValid(),
      )
      .test(
        'DOB',
        t(`OldInsurance.errors.future`),
        value => moment().diff(moment(value, dateFormat), 'years') >= 0,
      )
      .test(
        'DOB',
        t(`OldInsurance.errors.future`),
        value => moment().diff(moment(value, dateFormat), 'month') >= 0,
      )
      .test(
        'DOB',
        t(`OldInsurance.errors.future`),
        value => moment().diff(moment(value, dateFormat), 'day') >= 0,
      )
      .test(
        'DOB',
        t(`OldInsurance.errors.old`),
        value => moment().diff(moment(value, dateFormat), 'years') <= 80,
      ),
  });

  useEffect(() => {
    addBrowserHistory(location.pathname);
  }, []);

  useEffect(() => {
    let _return = true;
    if (Object.keys(finishedFetch).length === covCount) {
      Object.keys(finishedFetch).map(key => {
        if (!finishedFetch[key]) {
          _return = false;
        }
      });
      if (_return) {
        api.postSession().then(() => {
          setSendStep(`success`);
        });
      }
    }
  }, [finishedFetch]);

  useEffect(() => {
    let _isDisabled;
    switch (sendStep) {
      case 'pending':
        _isDisabled = true;
        break;
      case 'success':
        _isDisabled = true;
        if (valueChatMessage !== null) {
          addChatboxAnswer(
            t(`${getComponentName()}.response`, {
              startDate: `${valueChatMessage.day}/${valueChatMessage.month}/${valueChatMessage.year}`,
            }),
          );
        } else {
          addChatboxAnswer(t(`${getComponentName()}.responseNull`));
        }
        if (coverages.legal) {
          if (!coverages.family) {
            history.push(getNextPath('d'));
          } else {
            history.push(getNextPath('e'));
          }
          return;
        }
        if (coverages.home) {
          history.push(getNextPath('a'));
        } else if (coverages.family) {
          history.push(getNextPath('b'));
        } else {
          history.push(getNextPath('c'));
        }
        break;
      case 'error':
        _isDisabled = false;
        break;
      default:
        _isDisabled = false;
        break;
    }
    setIsDisabled(_isDisabled);
  }, [sendStep]);

  const disableHandler = (errors, touched) => {
    if (
      Object.entries(errors).length === 0 &&
      Object.entries(touched).length === 1
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  const handleAnswer = answer => {
    if (answer === content.answers[0].title) {
      setIsPending(true);
      setAnswer(1);
      clickHandler(null);
    } else {
      setIsPending(true);
      setAnswer(2);
      clickHandler();
    }
  };

  const clickHandler = values => {
    if (sendStep === 'pending') {
      // Don't allow to submit twice
      return;
    }
    const tempValues = values ? values : valuesHook;
    let fixedDate;
    if (values !== null) {
      fixedDate = {
        day: parseInt(tempValues['insurance_date'].split('-')[0]),
        month: parseInt(tempValues['insurance_date'].split('-')[1]),
        year: parseInt(tempValues['insurance_date'].split('-')[2]),
      };
    } else {
      fixedDate = null;
    }
    setValueChatMessage(fixedDate);
    setInsuredData('previous_insurance_start_date', fixedDate);
    setNoticeKey('car', 'noticeStartDate', fixedDate);
    setSendStep('pending');
    sendCarExtraData()
      .then(
        sendCarData()
          .then(() => {
            if (coverages.legal) {
              setSendStep(`success`);
            } else {
              resetSkippedSteps();
              removeFromCheckout('fire');
              removeFromCheckout('people');
              removeFromCheckout('car');
              removeFromCheckout('legal');
              let tempsomething = {};

              tempCov.map(coverage => {
                if (coverage.bool) {
                  tempsomething = {
                    ...tempsomething,
                    [coverage.type]: false,
                  };
                  resetMatchData();

                  const { type, campaign } = flowStore || {};
                  if (type === 'campaign' && campaign?.extend === 'LEAD') {
                    history.push('/thank-you-campaigns');
                    return;
                  }
                  getMatchData(coverage.type)
                    .then(r => {
                      setMatchData(
                        coverage.type === `home` ? `fire` : coverage.type,
                        r.data,
                      );
                      tempsomething = {
                        ...tempsomething,
                        [coverage.type]: true,
                      };
                      setFinishedFetch(tempsomething);
                    })
                    .catch(error => {
                      console.error(error.response);
                      setSendStep(`error`);
                    });
                }
              });
            }
          })
          .catch(error => {
            setSendStep('error');
            showErrorPopup(true);
            console.error(error.response);
          }),
      )
      .catch(error => {
        showErrorPopup(true);
        console.error(error.response);
      });
  };

  return (
    <Layout>
      <Container>
        <ChatBox showQuestion={true} />
        <InputQuestionBox
          question={t(`${getComponentName()}.question`)}
          Answer1={content.answers[0].title}
          dataTestId1="underwriting_answer_dontknow"
          dataTestId2="underwriting_answer_confirm"
          Answer2={content.answers[1].title}
          shouldLoad={isPending ? answer : undefined}
          mainDisabled={isDisabled}
          oneLine={true}
          response={answer => handleAnswer(answer)}
        >
          <Formik
            initialValues={{
              insurance_date: getInsuredData()
                ? getInsuredData().previous_insurance_start_date
                  ? `${getInsuredData().previous_insurance_start_date.day}-${
                      getInsuredData().previous_insurance_start_date.month
                    }-${getInsuredData().previous_insurance_start_date.year}`
                  : ''
                : '',
            }}
            validationSchema={SignupSchema}
            onSubmit={values => {
              clickHandler(values);
            }}
          >
            {({ errors, touched, setFieldValue, setFieldTouched, values }) => {
              disableHandler(errors, touched);
              setValuesHook(values);
              if (!touched.insurance_date) {
                if (
                  values.insurance_date !== '' &&
                  values.insurance_date !== null &&
                  values.insurance_date
                )
                  setFieldTouched('insurance_date');
              }
              return (
                <Form>
                  <DateInput
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    dataTestId="underwriting_car_insurance_startdate"
                    type="text"
                    disabled={false}
                    name="insurance_date"
                  />
                </Form>
                /* <Answers>
                  <Answer disabled={isDisabled} type="submit">
                    {t(`${getComponentName()}.confirm`)}
                  </Answer>
                </Answers> */
              );
            }}
          </Formik>
        </InputQuestionBox>
      </Container>
    </Layout>
  );
};

OldInsuranceStartDateInput.propTypes = {
  history: shape().isRequired,
};

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  align-items: center;
  font-size: 2rem;
  line-height: 2.6rem;
  position: relative;

  & span {
    font-weight: bold;
  }

  & div:first-child {
    z-index: 10;
  }
`;

OldInsuranceStartDateInput.propTypes = {
  history: shape().isRequired,
};

export default withRouter(OldInsuranceStartDateInput);
